import React, { useCallback, useMemo, useState } from 'react';

import Form from '@lyearn/form';
import { useTranslation } from '@lyearn/i18n';
import { AttachOutlineLegacy } from '@lyearn/icons';
import { Box, Button, Typography } from '@lyearn/ui';

import { FORM_OVERRIDES } from './consts';
import { getFormFields, INITIAL_VALUES, validateForm } from './form';
import { FormValues, UploadSubtitleProps } from './types';

const UploadSubtitle: React.FC<UploadSubtitleProps> = (props) => {
  const { setFile, file, onCaptionSubmit, captionsState } = props;
  const [formikSubmit, setFormikSubmit] = useState();
  const { t } = useTranslation();
  const { fields } = useMemo(
    () => ({ fields: getFormFields(t, captionsState) }),
    [captionsState, t],
  );

  const onSubmit = useCallback(
    (values: FormValues) => {
      onCaptionSubmit(values.language);
    },
    [onCaptionSubmit],
  );

  return (
    <Box className="mt-24 rounded-8 border border-border p-12 shadow-01">
      <Form<FormValues>
        fields={fields}
        formName="UploadSubtitleForm"
        initialValues={INITIAL_VALUES}
        overrides={FORM_OVERRIDES}
        setSubmitRef={setFormikSubmit}
        validate={validateForm(t)}
        onSubmit={onSubmit}
      />
      <Box className="mt-16 flex rounded-8 border border-border bg-bg-secondary px-12 py-10">
        <AttachOutlineLegacy
          className="flex-shrink-0 text-icon-placeholder"
          height={20}
          width={20}
        />
        <Typography className="text-text-secondary ps-8" numberOfLines={1} variant="body-short-02">
          {file.name}
        </Typography>
      </Box>
      <Box className="mt-24 flex justify-between">
        <Button
          appearance="inverse"
          className="w-48 border border-solid border-divider"
          variant="filled"
          onClick={() => setFile(null)}>
          {t('Common:Actions.Cancel')}
        </Button>
        <Button appearance="primary" className="w-48" variant="filled" onClick={formikSubmit}>
          {t('Common:Actions.Save')}
        </Button>
      </Box>
    </Box>
  );
};

export default UploadSubtitle;
